import {
  WS_CONNECTED,
  WS_DISCONNECTED,
} from './constants';

import {IWebSocketAction} from './actions';

export interface IWebSocketState {
  connected: boolean;
}

const initialState: IWebSocketState = {
  connected: false,
};

export default function webSocketReducer(
  state: IWebSocketState = initialState,
  action: IWebSocketAction,
): IWebSocketState {
  switch (action.type) {
    case WS_CONNECTED:
      return {...state, connected: true};

    case WS_DISCONNECTED:
      return {...state, connected: false};

    default:
      return state;
  }
}
